import * as React from 'react'
import Link from 'next/link'
import { ShopPageProductBlockWrapper } from './styles'
import { ProductLinkBlock } from '../../types/sanity'
import { Heading } from '@/components/Text'
import { formatPrice } from '@/utils'

interface ShopPageProductBlockProps {
  content: ProductLinkBlock
}

export const ShopPageProductBlock: React.FC<ShopPageProductBlockProps> = ({
  content,
}) => {
  const { product } = content
  if (!product) return null
  const imageUrl = product.store?.previewImageUrl
  if (!imageUrl) return null
  const title = product.store?.title
  const price = product.store?.priceRange?.minVariantPrice
  const linkTo = `/products/${product.store?.slug?.current}`
  return (
    <ShopPageProductBlockWrapper>
      <Link href={linkTo}>
        <img className="product_thumb" src={imageUrl} alt={title || ''} />
        <Heading
          level="h2"
          fontFamily="sans"
          fontWeight={5}
          textTransform="uppercase"
          fontSize={3}
        >
          {title}
          <br />
          {price ? formatPrice(price) : null}
        </Heading>
      </Link>
    </ShopPageProductBlockWrapper>
  )
}
